import type { ReactNode } from 'react';

interface CardsProps {
  cols?: number;
  children?: ReactNode;
}

export function Cards({ cols = 3, children }: CardsProps) {
  const colClass =
    cols >= 4
      ? 'md:grid-cols-2 lg:grid-cols-4'
      : cols === 2
        ? 'md:grid-cols-2'
        : 'md:grid-cols-2 lg:grid-cols-3';
  return (
    <div className={`my-6 grid grid-cols-1 ${colClass} gap-5`}>
      {children}
    </div>
  );
}

interface CardProps {
  title?: string;
  children?: ReactNode;
}

export function Card({ title, children }: CardProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5 lg:p-6 border-l-[3px] border-l-[#D5B13A]/40 hover:border-l-[#D5B13A] transition-colors">
      {title && (
        <div className="font-heading text-lg font-bold text-[#2D7E32] mb-2 leading-tight not-prose">
          {title}
        </div>
      )}
      <div className="text-[#2E4A3A] font-body leading-relaxed text-sm lg:text-base [&>p]:my-2 [&>p:first-child]:mt-0 [&>p:last-child]:mb-0">
        {children}
      </div>
    </div>
  );
}
